import {
  CURRENCY_INIT,
  CURRENCY_SET,
  CURRENCY_DEFAULT_REQUEST,
  CURRENCY_DEFAULT_SUCCESS,
  CURRENCY_DEFAULT_FAILURE,
} from '../actions/currency'
import { DEFAULT_CURRENCY, normalizeCurrency } from '../utils/currency'

/**
 * code        divisa que se está mostrando ahora mismo
 * defaultCode divisa por defecto del cliente (ficha Customer.Currency, resuelta por el API)
 * source      'default' = sigue a defaultCode | 'user' = elegida a mano en la barra superior
 */
const INITIAL_STATE = {
  authId: null,
  code: DEFAULT_CURRENCY,
  defaultCode: DEFAULT_CURRENCY,
  source: 'default',
  loading: false,
  error: null,
}

const currencyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CURRENCY_INIT:
      return {
        ...state,
        authId: action.authId,
        code: action.code,
        defaultCode: action.defaultCode,
        source: action.source,
        error: null,
      }
    case CURRENCY_SET:
      return { ...state, code: action.code, source: 'user' }
    case CURRENCY_DEFAULT_REQUEST:
      return { ...state, loading: true }
    case CURRENCY_DEFAULT_SUCCESS: {
      const defaultCode = normalizeCurrency(action.response && action.response.Currency) || DEFAULT_CURRENCY
      return {
        ...state,
        loading: false,
        defaultCode,
        code: state.source === 'user' ? state.code : defaultCode,
      }
    }
    case CURRENCY_DEFAULT_FAILURE:
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}

export default currencyReducer
